module.exports = __webpack_public_path__ + "static/media/SuccessLocation.594aeb91.svg";